<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Blur Background" class="d-icon d-icon--blur-background" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M.94 1.5a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm2 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm5.002 0a.56.56 0 1 1 1.121 0 .56.56 0 0 1-1.12 0Zm1.998 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0ZM6 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3.5 3.5a2.5 2.5 0 1 1 4.961.441.56.56 0 1 1-.374.935A2.498 2.498 0 0 1 6 6a2.498 2.498 0 0 1-2.086-1.122.559.559 0 0 1-.974-.378.56.56 0 0 1 .599-.559 2.515 2.515 0 0 1-.039-.44ZM1.94 3a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0ZM9 3a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H9.5A.5.5 0 0 1 9 3ZM.94 4.5a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm9 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm-8 1.5a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm7 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm-.81 1.08a.56.56 0 0 1 .93.466A2.5 2.5 0 0 1 10 9.5v1a.5.5 0 1 1-1 0v-1A1.5 1.5 0 0 0 7.5 8h-3A1.5 1.5 0 0 0 3 9.5v1a.5.5 0 1 1-1 0v-1a2.5 2.5 0 0 1 .941-1.955.56.56 0 0 1 .93-.465 2.5 2.5 0 0 1 .63-.08h3c.214 0 .425.028.63.08Zm1.81.42a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Zm-9 0a.56.56 0 1 1 1.12 0 .56.56 0 0 1-1.12 0Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconBlurBackground',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
